import { Outlet } from "react-router-dom";
import { ApplicantRequest } from "./applicant-request";
import { Layout } from "antd";
const { Content, Sider } = Layout;

export const ApplicantRequestContainer = (props: { applicantId: any; }) => {
	return (
		<Layout
			style={{ minHeight: "150vh", marginTop: "-10px" }}
			hasSider
		>
			<Sider
				width={300}
				style={{
					textAlign: "center",
					background: "transparent",
					marginLeft: "0px",
					boxShadow: "-2px 0 12px rgba(0, 0, 0, 0.1)",
				}}
				theme="light"
			>
				<ApplicantRequest applicantId={props.applicantId} />
			</Sider>
			<Content
				style={{
					boxShadow: "-2px 0 12px rgba(0, 0, 0, 0.1)",
					background: "transparent",
					padding: "10px",
					zIndex: 2,
				}}
			>
			<Outlet />
			</Content>
		</Layout>
	);
}